import * as S from './PayAtHotelPersuasion.styles';

// ICONS
import PayAtHotelIcon from '../../../../../../stories/Icons/PayAtHotel';
import PayAtHotelCCIcon from '../../../../../../stories/Icons/PayAtHotelCC';

const PayModePersuasionInfo: React.FC<{paymode}> = ({paymode}) => {
  if (!paymode || ['PAH_WITHOUT_CC', 'PAH_WITH_CC'].indexOf(paymode) === -1) return null;

  return (
    <S.PayModePersuasionContainer>
      {paymode === 'PAH_WITHOUT_CC' && (
        <>
          <PayAtHotelIcon width="2.5rem" height="2.5rem" />
          <S.PayModePersuasionTextsContainer>
            <S.PayModePersuasionTextContainer>Pay at Hotel</S.PayModePersuasionTextContainer>
            <S.TaxesTextStyled>
              <S.PayAtHotelTaxesText>Credit card not required</S.PayAtHotelTaxesText>
            </S.TaxesTextStyled>
          </S.PayModePersuasionTextsContainer>
        </>
      )}

      {paymode === 'PAH_WITH_CC' && (
        <>
          <PayAtHotelCCIcon />
          <S.PayModePersuasionTextsContainer>
            <S.PayModePersuasionTextContainer>Pay At Hotel</S.PayModePersuasionTextContainer>
            <S.PayModePersuasionCardTextContainer>
              Credit card details required
            </S.PayModePersuasionCardTextContainer>
          </S.PayModePersuasionTextsContainer>
        </>
      )}
    </S.PayModePersuasionContainer>
  );
};

export default PayModePersuasionInfo;
